// @ts-nocheck
import Api from "@/services/Api";
import Api2 from "@/services/Api2";

export function isStepStateComplete(stepState) {
  const s = stepState ?? {};
  return (
    !!s.academyProfile &&
    !!s.addedMembers &&
    !!s.setupProductsMemberships &&
    !!s.automaticPayments &&
    !!s.setupSchedule
  );
}

function getAcademyUserKey({ managedAcademy, userId }) {
  if (!managedAcademy || !userId) return null;
  return `${managedAcademy}:${userId}`;
}

/**
 * Centralized completion helper:
 * - completes onboarding step
 * - refreshes step state
 * - shows "setup complete" dialog once per academy+user
 *
 * @param {{
 *   step: string,
 *   managedAcademy: string,
 *   store: any,
 * }} params
 */
export async function completeOnboardingStep({ step, managedAcademy, store }) {
  
  const onboardingStepState = store?.state?.onboardingStepState ?? {};
  const isUserAdminPlus = store?.state?.isUserAdminPlus ?? false;

  if(!isUserAdminPlus) {
    return { stepState: null, isComplete: true };
  }
  
  if(onboardingStepState[step]) {
    return { stepState: onboardingStepState, isComplete: true };
  }

  if (!step || !managedAcademy) {
    return { stepState: null, isComplete: false };
  }

  try {
    await Api().post("trial/completeStep", { step, managedAcademy });
  } catch (_e) {
    // Step completion should never block the main UX.
  }

  let stepState = null;
  try {
    const response = await Api2().post("trial/stepState", { managedAcademy });
    stepState = response?.data ?? null;
  } catch (_e) {
    stepState = null;
  }

  const isComplete = isStepStateComplete(stepState);
  store.dispatch("setIsOnboardingUser", !!isComplete);

  if (isComplete && store) {
    const userId = store?.state?.user?._id ?? store?.state?.user?.id ?? null;
    const key = getAcademyUserKey({ managedAcademy, userId });
    const alreadyShown =
      !!key && !!store?.state?.setupCompleteDialogShownByAcademyUser?.[key];

    if (key && !alreadyShown) {
      store.dispatch("markSetupCompleteDialogShown", {
        managedAcademy,
        userId,
      });
      store.dispatch("setSetupCompleteDialogVisible", true);
    }
  }

  return { stepState, isComplete };
}

/**
 * Get the onboarding step state for a given managed academy.
 * @param {string} managedAcademy - The managed academy to get the onboarding step state for.
 * @returns {Promise<any>} The onboarding step state.
 */
export async function getOnboardingStepState(managedAcademy) {
  if (!managedAcademy) return null;
  try {
    const response = await Api2().post("trial/stepState", { managedAcademy });
    return response?.data ?? null;
  } catch (_e) {
    return null;
  }
}
